module.exports = __webpack_public_path__ + "static/media/clients.cd1ac489.svg";